export default __webpack_public_path__ + "static/Entenda0114-ddeb74a90214a2e26973c3d5035ccdd8.jpg";